import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { AppActionCreators, IApplicationState, INkrReferralDonatedNkrResponse, ReferralActionCreators } from '@nkr/store/index';
import { INkrReferralDonatedNkr } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { IHeaderParams, GridApi, GridReadyEvent, ValueGetterParams, ProcessCellForExportParams, CsvExportParams, ColDef, FirstDataRenderedEvent, SortChangedEvent } from 'ag-grid-community';
import { ReportWrapper } from './styles';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Button } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';

interface IOwnProps {
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getNkrReferralDonatedNkr: () => Promise<INkrReferralDonatedNkrResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: INkrReferralDonatedNkr[],
    recipientCenterId: number,
    gridApi: GridApi,
    columns: ColDef[]
}

class NkrReferralDonatedNkr extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        recipientCenterId: 0,
        gridApi: null,
        columns: [
            {
                colId: 'rank',
                headerName: 'Row #',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Row #</SortableHeaderComponent>,
                width: 50,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },

            {
                colId: 'centerAlias',
                field: 'centerAlias',
                headerName: 'Center',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Center</SortableHeaderComponent>,
                comparator: Utility.stringSortComparator,
                width: 100
            },

            {
                colId: 'allDashDonorsTransplanted',
                field: 'allDashDonorsTransplanted',
                headerName: 'All Dash Donors Transplanted',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>All Dash Donors Transplanted</SortableHeaderComponent>,
                width: 100
            },

            {
                colId: 'referredDonorsTransplanted',
                field: 'referredDonorsTransplanted',
                headerName: 'Referred Donors Transplanted',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Referred Donors Transplanted</SortableHeaderComponent>,
                width: 100
            },
        ]
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting data, one moment please...').then(() => {
            this.props.getNkrReferralDonatedNkr().then(response => {
                this.setState({
                    data: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'nkr-referrals-that-donate-in-nkr.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div style={{ fontSize: 28, fontWeight: 500 }}>NKR Referrals that Donate in NKR</div>
                    <div>
                        <Button onClick={this.handleExport}>Export CSV</Button>
                    </div>
                </div>

                <ReportWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        defaultColDef={{
                            headerClass: 'list-header',
                            cellClass: 'list-cell',
                            sortable: true,
                            resizable: false
                        }}
                        columnDefs={this.state.columns}
                        rowData={this.state.data}
                        headerHeight={30}
                        rowHeight={30}
                        suppressRowClickSelection={false}
                        suppressCellSelection={true}
                        noRowsOverlayComponentFramework={() => <div>No records...</div>}
                        onGridReady={this.onGridReady}
                        onFirstDataRendered={this.onFirstDataRendered}
                        onSortChanged={(e: SortChangedEvent) => {
                            e.api.refreshCells();
                        }}
                    />
                </ReportWrapper>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getNkrReferralDonatedNkr: () => {
            return dispatch(ReferralActionCreators.getNkrReferralDonatedNkr());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(NkrReferralDonatedNkr);